// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__JDE36","link":"default_link__6jDoI"};